import React from "react";
import { Button } from "./Button";

interface AutopilotOwnListingBlockedProps {
  open: boolean;
  onClose: () => void;
}

// MB-1424: hard block - the user tried to manually add one of their own
// listings while Autopilot is on. There is deliberately no "add anyway":
// auto-ingest already owns that listing.
const AutopilotOwnListingBlocked: React.FC<AutopilotOwnListingBlockedProps> = ({
  open,
  onClose,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
        <h2 className="text-xl font-bold text-primary mb-4">
          Auto Pilot has this covered
        </h2>
        <p className="mb-2 text-gray-700 text-sm">
          This is one of your own listings - Auto Pilot adds those automatically
          as soon as they hit the MLS, so there is nothing to do here.
        </p>
        <p className="mb-4 text-gray-700 text-sm">
          Manual add is for marketing another agent&apos;s listing.
        </p>
        <div className="flex justify-center">
          <Button onClick={onClose}>Got it</Button>
        </div>
      </div>
    </div>
  );
};

export default AutopilotOwnListingBlocked;
